import './SliderA.scss';

import { b2x } from '@b2x/react/src';
import classnames from 'classnames';
import React from 'react';

import { Button } from './Button';
import { ComponentWrapper } from './ComponentWrapper';
import { SliderAContentType } from './contentTypes';
import { t } from './i18n/i18n';

export const SliderA = ({ options, slides }: SliderAContentType) => {
  const { getPagePath } = b2x.useAppStaticContext();

  return (
    <ComponentWrapper
      classNames="slider-a"
      options={{
        ...options,
        container: undefined,
        margin: {
          bottom: options?.margin?.bottom,
          top: undefined,
        },
        padding: {
          bottom: undefined,
          top: undefined,
        },
      }}
    >
      {slides?.length && slides.length > 0 && (
        <b2x.SwiperContext>
          {({ navigationNextElRef, navigationPrevElRef }) => (
            <b2x.Div className="position-relative">
              <b2x.Swiper
                navigation={{ custom: true }}
                pagination={{ clickable: true }}
                slides={slides.map((slide) => {
                  const alignItems = slide.options?.contentAlignment?.vertical as b2x.ResponsiveAlignItems;
                  const justifyContent = slide.options?.contentAlignment?.horizontal as b2x.JustifyContent;
                  const textAlign = slide.options?.textAlign as b2x.TextAlign;
                  const headingType = slide.options?.headingType as string;

                  return (
                    <b2x.Div className="position-relative" key={slide.contentSectionId}>
                      {slide.asset?.type && (
                        <b2x.Div className="asset">
                          <b2x.router.Link
                            aria-label={t('accessibility.advantages')}
                            to={
                              slide.content?.cta?.to?.href
                                ? slide.content.cta.to.href
                                : slide.content?.cta?.to?.code && getPagePath(slide.content.cta.to.code)
                            }
                          >
                            <b2x.AssetV2 {...slide.asset} fluid />
                          </b2x.router.Link>
                        </b2x.Div>
                      )}
                      {(slide.content?.title || slide.content?.message) && (
                        <b2x.Div
                          alignItems={alignItems}
                          className="content-wrapper"
                          display={'flex'}
                          paddingBottom={{ lg: 5, xs: 3 }}
                          paddingTop={{ lg: 5, xs: 4 }}
                          paddingX={{ lg: 5, xs: 0 }}
                          style={{ pointerEvents: 'none' }}
                        >
                          <b2x.Container>
                            <b2x.Div display={'flex'} justifyContent={{ lg: justifyContent, xs: 'center' }}>
                              <b2x.Div
                                className="content"
                                display={'flex'}
                                flexDirection={'column'}
                                gap={3}
                                paddingX={{ lg: 5, xs: 4 }}
                                style={{ pointerEvents: 'initial' }}
                                textAlign={{ lg: textAlign, xs: 'center' }}
                              >
                                {slide.content.title &&
                                  React.createElement(headingType, { class: 'h1 m-0' }, slide.content.title)}
                                {slide.content.message && (
                                  <b2x.Div className={classnames('h3 m-0')}>
                                    {b2x.formatHtml(slide.content.message)}
                                  </b2x.Div>
                                )}
                                {slide.content.cta?.label && (
                                  <b2x.Div>
                                    <b2x.CtaFromContent
                                      {...slide.content.cta}
                                      variant={slide.content.cta.variant !== '' ? slide.content.cta.variant : 'primary'}
                                    />
                                  </b2x.Div>
                                )}
                              </b2x.Div>
                            </b2x.Div>
                          </b2x.Container>
                        </b2x.Div>
                      )}
                    </b2x.Div>
                  );
                })}
                slidesPerView={1}
              />
              <b2x.Div
                alignItems={'center'}
                className="position-absolute w-100 h-100 top-0 left-0"
                display={{ lg: 'flex', xs: 'none' }}
                justifyContent={'spaceBetween'}
                paddingX={2}
                style={{ pointerEvents: 'none', zIndex: 100 }}
              >
                <Button
                  aria-label={t('accessibility.button.swiper_prev')}
                  className={slides.length === 1 ? 'd-none' : ''}
                  iconStart={{ name: 'arrow-left', size: 40 }}
                  innerRef={navigationPrevElRef}
                  style={{ pointerEvents: 'initial' }}
                  variant="blank"
                />
                <Button
                  aria-label={t('accessibility.button.swiper_next')}
                  className={slides.length === 1 ? 'd-none' : ''}
                  iconStart={{ name: 'arrow-right', size: 40 }}
                  innerRef={navigationNextElRef}
                  style={{ pointerEvents: 'initial' }}
                  variant="blank"
                />
              </b2x.Div>
            </b2x.Div>
          )}
        </b2x.SwiperContext>
      )}
    </ComponentWrapper>
  );
};
